import { trigger, transition, animate, style } from '@angular/animations';

export const animations = [
  trigger('slideInOutFadeInOut', [
    transition(':enter', [
      style({
        opacity: '0',
        transition: 'opacity 0.3s',
        transform: 'translateY(-40%)',
      }),
      animate(
        '200ms ease',
        style({
          opacity: '1',
          transform: 'translateY(0%)',
        })
      ),
    ]),
    transition(':leave', [
      animate(
        '200ms ease',
        style({
          opacity: '0',
          transform: 'translateY(-20%)',
        })
      ),
    ]),
  ]),
];
